
const CareerInternshipData = [
    {
        id: 1,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/Resume-&-LinkedIn.png"),
        text: "Resume & LinkedIn audits"
    },
    {
        id: 2,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/CPT-OPT-guidance.png"),
        text: "CPT/OPT guidance and timelines"
    },
    {
        id: 3,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/Internship-search.png"),
        text: "Internship search strategies"
    },
    {
        id: 4,
        bannerImg: require("../../../Assets/Gulf_Students/Carrer_&_Internship/Industry-specific.png"),
        text: "Industry-specific webinar series"
    }
];

export default CareerInternshipData;